import React from "react";

import { classNames } from "repoV2/utils/common/render/classNames";

import { ILoadingSpinner } from "./LoadingSpinner";

import styles from "./loadingSpinner.module.scss";

/**
 * @deprecated use `repoV2/components/common/LoadingIndicators/index.tsx`
 */
const LoadingSpinner = ({
    className = "",
    small = false, // Whether the full-page element is needed or just the spinner
}: ILoadingSpinner.IProps): JSX.Element =>
    small ? (
        <div className={classNames(styles.spinner, className)} />
    ) : (
        <div className={classNames(styles.spinnerContainer, className)}>
            <div className={styles.spinner} />
        </div>
    );

export default LoadingSpinner;
